<template>
  <div id="customization">
    <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" ref="loadmore" v-show="!noDataList"
                 :autoFill="false" :bottom-all-loaded="allLoaded"
    >
      <ul id="uls">
        <li v-for="(item, index) in dataList" :keyss="String(index)" class="customization-item border-1px">
          <div :keyss="String(index)">
            <p :keyss="String(index)" class="font34">{{item.potName}}</p>
            <p :keyss="String(index)" class="font26">定制门店：{{item.shopNickName}}&nbsp;{{item.shopName}}</p>
          </div>
          <span :keyss="String(index)" class="collect" v-show="item.source === 2">
            <img :src="collectionImg" alt="">
          </span>
          <i :keyss="String(index)" class="iconfont icon-right right-icon"></i>
        </li>
      </ul>
    </mt-loadmore>
    <div class="dataListOver" v-show="dataListOver">——————&nbsp;&nbsp;加载完成&nbsp;&nbsp;——————</div>
    <div class="noDataList" v-show="noDataList">——————&nbsp;&nbsp;您还没有私人定制记录&nbsp;&nbsp;——————</div>
  </div>
</template>
<script>
  import {Loadmore, Indicator} from 'mint-ui';
  import TitleBar from '../taste-index'
  import ajax from '../../../pub/utils/ajaxUtils.js'
  import mainUtils from '../../../pub/utils/mainUtils'
  import {queryDetailHdl} from '../config/api.js'
  const collectionImg = require('../../../assets/images/collectionImg.png')
  const collectiedImg = require('../../../assets/images/collectedImg.png')
  export default {
    methods: {
      customizationItemTransmit(e) {
        let i = e.target.getAttribute('keyss');
        let _string = JSON.stringify(this.dataList[i]);
        return WebViewJavascriptBridge.privatePotTastes(_string);
      },
      loadTop() {
        this.removeClick();
        this.pageNum = 1;
        this.dataListOver = false;
        this.allLoaded = false;
        this.getList(this.$refs.loadmore.onTopLoaded);
      },
      loadBottom() {
        this.removeClick();
        this.pageNum++;
        this.getList(this.$refs.loadmore.onBottomLoaded);
      },
      getList(cb) {
        if (this.totalPageCount === 0) {
          this.noDataList = true;
          return;
        }
        /*if (this.totalPageCount >= this.pageNum) {
          let params = {
            token: this.propsInfo.token,
            shopId: this.propsInfo.shopId,
            memberId: this.propsInfo.phone,
            companyId: this.propsInfo.companyId,
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            ip: this.propsInfo.ip
          };*/
        if (this.pageNum === 1) {
          let params = {
            memberId: this.propsInfo.memberId,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          };
          ajax.postJson(queryDetailHdl, params,
            data => {
              if (data.result === 200) {
                if (data.obj.list) {
                  this.allData = data.obj.list;
                  let len = this.allData.length;
                  if (len === 0) this.noDataList = true;
                  if (len <= 10) {
                    this.allLoaded = true;
                    this.dataList = this.allData;
                  }
                  else this.dataList = this.allData.splice(0, 10);
                  // this.pageRecordCount = data.obj.pageRecordCount;
                  // this.totalPageCount = Math.ceil(this.pageRecordCount / this.pageSize);
                  // if (this.totalPageCount === 0) this.noDataList = true;
                  // if (this.pageNum === 1) this.dataList = data.obj.list;
                  // else this.dataList = this.dataList.concat(data.obj.list);
                  // if (this.dataList.length < 10 && this.pageNum === 1) this.allLoaded = true;
                }
                else this.noDataList = true;
                if (cb) cb();
              }
            }
          )
        }
        else {
          if (this.allData.length === 0) {
            this.allLoaded = true;
            this.dataListOver = true;
            if (cb) cb();
          }
          else setTimeout(() => {
            this.dataList = this.dataList.concat(this.allData.splice(0, 10));
            if (cb) cb();
          }, 500);
        }
      },
      removeClick() {
        let uls = document.getElementById('uls');
        uls.removeEventListener('click', this.customizationItemTransmit);
      },
      handleTouchEnd() {
        this.$nextTick(() => {
          let uls = document.getElementById('uls');
          setTimeout(() => {
            uls.addEventListener('click', this.customizationItemTransmit);
          }, 100)
        })
      },
    },
    data() {
      return {
        wrapperHeight: 0,
        dataListOver: false,// 请求完毕
        noDataList: false,// 没有数据
        pageSize: 999999,// 条数
        pageNum: 1,// 页码
        totalPageCount: 999999999999,// 总页码
        pageRecordCount: 999999999999,// 总条数
        propsInfo: {
          token: '',
          shopId: '',
          phone: '',// 私人定制 -- 手机号 历史锅底 -- 会员ID
          memberId: '',// 私人定制 -- 手机号 历史锅底 -- 会员ID
          companyId: '',
          ip: '',
        },
        dataList: [],
        allData: [],
        allLoaded: false,
        collectionImg: collectiedImg
      }
    },
    created() {
      console.log(11111)
      this.$nextTick(() => {
        let uls = document.getElementById('uls');
        uls.addEventListener('click', this.customizationItemTransmit);
        uls.addEventListener('touchmove', this.removeClick);
        uls.addEventListener('touchend', this.handleTouchEnd);
        this.propsInfo = Object.assign(this.propsInfo, mainUtils.pathName());
        this.getList();
      })
    },
    components: {Loadmore, Indicator, TitleBar},
  }
</script>
<style lang="stylus">
  @import "../../../assets/css/func.styl"
  #customization
    box-sizing: border-box
    height: calc(100% - 1.2rem)
    .font34
      font-size .34rem
      font-weight 900
      margin-bottom: .2rem
    .font26
      font-size .26rem
    .list-chunk
      min-height: 100%
      overflow: scroll;
    ul
      margin: 0 .4rem
    .customization-item
      display: flex
      flex-direction: row
      align-items: center
      width: 8rem
      height: 1.8rem
      padding-left: .08rem
      bb-1px(#f3f3f3)
      font-size: .34rem
      div
        flex: 1
        min-width: 6.64rem
        p
          width: 100%
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
      .collect
        display: inline-block
        width: 1.13rem
        height: .9rem
        margin-right .2rem
        text-align center
        line-height: .5rem
        // font-size: .22rem
        // color: #fff
        // background: #ff9800
        // border-radius: .25rem
        img
          width: 1.13rem
          height: .9rem
      .right-icon
        width: .26rem
        color: #ff9800
        font-size: 0.34rem;
    .dataListOver
      text-align center
      line-height .9rem
      font-size: .34rem
      color: #e3e3e3
    .noDataList
      text-align center
      line-height 1.8rem
      font-size: .34rem
</style>



// WEBPACK FOOTER //
// src/components/taste/customization/customization.vue